// components/Authors/RedirectAuthorById.jsx
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getAuthorDetail } from "../../services/authorService";
import { buildAuthorPath } from "../../utils/slugify";
import { AppContext } from "../../services/AuthContext";
import { useContext } from "react";

export default function RedirectAuthorById() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { auth } = useContext(AppContext);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getAuthorDetail(id, auth?.token);
        if (!alive) return;
        if (res?.status === "OK") {
          const { name, surname } = res.data || {};
          navigate(buildAuthorPath({ name, surname, id }), { replace: true });
        } else {
          navigate("/home", { replace: true });
        }
      } catch {
        navigate("/home", { replace: true });
      }
    })();
    return () => { alive = false; };
  }, [id, navigate]);

  return null; // kısa bir loading gösterebilirsin
}
